<template>
  <div>
    <div
      ref="map"
      style="width: 100%; height: 700px; background: #c9c9c9;"
    ></div>

    <div
      v-if="isToggleButtons"
      class="b-vendors__header-btns b-vendors__header-btns--map"
    >
      <v-btn
        :outlined="!onlyPs"
        class="customer-toggle-button mr-2"
        color="blue"
        dark
        depressed
        @click="toggleCustomerType('ps')"
      >
        Производственные площадки
      </v-btn>

      <v-btn
        :outlined="!onlyCompanies"
        class="customer-toggle-button"
        color="red"
        dark
        depressed
        @click="toggleCustomerType('companies')"
      >
        Компании
      </v-btn>
    </div>
  </div>
</template>

<script>
import { companiesService } from "@/services/companies-service";
import { Loader } from "@googlemaps/js-api-loader";
import MarkerClusterer from "@google/markerclustererplus";

export default {
  name: "CustomersMap",
  props: {
    center: {
      type: Array,
      default: () => [61.49806090959257, 23.75323191521061]
    },
    filteredItems: {
      type: Array,
      default: () => []
    },
    isToggleButtons: {
      type: Boolean,
      default: false
    },
    mapContainer: {
      type: HTMLElement,
      default: () => {}
    },
    searchQuery: {
      type: String,
      default: ""
    },
    viewType: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    balloon: null,
    loader: new Loader({
      apiKey: "AIzaSyCFTuQHDD8F6sxreiYVMFRsEWoEDWCXofI",
      version: "weekly",
      language: "en"
    }),
    map: null,
    markers: [],
    customerToggler: true,
    onlyPs: false,
    onlyCompanies: false,
    customerType: "",
    objectManager: null,
    markerClusterer: null
  }),
  computed: {
    search() {
      return this.searchQuery || "";
    },
    selectedCustomer() {
      return this.$store.getters.selectedCustomer;
    },
    customers() {
      if (this.customerType === "ps") {
        return this.filteredItems.filter(
          cur =>
            cur.type === "ps" &&
            cur.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        );
      }
      if (this.customerType === "companies") {
        return this.filteredItems.filter(
          cur =>
            cur.type === "company" &&
            cur.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        );
      }

      return this.filteredItems.filter(
        cur => cur.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
      );
    },
    locations() {
      return this.customers.map(customer => {
        const [lat = 0, lng = 0] = customer.coords || [];

        return {
          position: { lat, lng },
          name: customer.name,
          id: customer.id,
          type: customer.type
        };
      });
    },
    getMappedCenterCoords() {
      const [lat = 34.397, lng = 150.644] = this.center || [];

      return { lat, lng };
    }
  },
  created() {
    window.setSelectedCustomer = this.setSelectedCustomer;
  },
  watch: {
    viewType: {
      immediate: true,
      handler: function(value) {
        if (value === "map") {
          this.initMap();
        }
      }
    },
    filteredItems: {
      immediate: false,
      handler: function() {
        if (!this.map) return;

        console.debug("Map was rendered");

        this.removeAllMarkers();
        this.addMarkers(this.locations);
      }
    },
    search: {
      immediate: false,
      handler: function() {
        if (!this.map) return;

        this.removeAllMarkers();
        this.addMarkers(this.locations);
      }
    }
  },
  methods: {
    async initMap() {
      this.loader.load().then(async () => {
        // eslint-disable-next-line no-undef
        const { Map } = await google.maps.importLibrary("maps");

        this.map = new Map(this.$refs.map, {
          center: this.getMappedCenterCoords,
          zoom: 8
        });

        // eslint-disable-next-line no-undef
        this.balloon = new google.maps.InfoWindow();

        // eslint-disable-next-line no-undef
        google.maps.event.addListenerOnce(this.map, "idle", () => {
          this.addMarkers(this.locations);
        });
      });
    },
    addMarkers(locations = []) {
      locations.forEach(item => {
        // eslint-disable-next-line no-undef
        const marker = new google.maps.Marker({
          position: item.position,
          map: this.map,
          id: item.id,
          type: item.type,
          name: item.name,
          title: item.name
        });

        // Добавляем слушатель клика на маркер
        marker.addListener("click", () => {
          this.setSelectedCustomer(marker.id);
          this.balloon.close();
        });

        this.markers.push(marker);
      });

      // Удаляем старый кластеризатор, если он существует
      if (this.markerClusterer) {
        this.markerClusterer.clearMarkers();
        this.markerClusterer = null;
      }

      // Создаем новый кластеризатор и добавляем кластеры на карту
      this.markerClusterer = new MarkerClusterer(this.map, this.markers, {
        imagePath: "https://elcats.elmc.com/upload/m/m"
      });

      // Добавляем слушатель клика на кластеры
      // eslint-disable-next-line no-undef
      google.maps.event.addListener(
        this.markerClusterer,
        "clusterclick",
        cluster => {
          // Получаем маркеры, содержащиеся в кластере
          const markersInCluster = cluster.getMarkers();

          let content = '<div><ul class="balloon-list">';

          // Генерируем содержимое для InfoWindow с информацией о каждом маркере
          markersInCluster.forEach(marker => {
            content += `
            <li
              onclick="setSelectedCustomer(${marker.id})"
              data-customer-id="${marker.id}"
              class="balloon-item-${marker.type}"
            >
              <span></span>

              <strong
                data-placemarkid="${marker.id}"
              >
                ${marker.name}
              </strong>
            </li>
          `;
          });
          content += "</ul></div>";

          // Устанавливаем контент и открываем InfoWindow на позиции кластера
          this.balloon.setContent(content);
          this.balloon.setPosition(cluster.getCenter());
          this.balloon.open(this.map);
        }
      );
    },
    removeAllMarkers() {
      // Удаляем старый кластеризатор, если он существует
      if (this.markerClusterer) {
        this.markerClusterer.clearMarkers();
        this.markerClusterer = null;
      }

      // Удаляем все маркеры с карты
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }

      this.markers = [];
    },
    setSelectedCustomer(customerID) {
      const customer = this.filteredItems.find(
        customer => customerID === customer.id
      );

      if (customer) {
        this.$store.dispatch("setSelectedCustomer", customer);
        this.$emit("show-customer-card");
        this.$emit("change-company", { id: customer.id, name: customer.name });

        companiesService
          .setActiveCompany(customer.id, customer.name)
          .catch(err => {
            throw err;
          });

        const targetCustomerInBalloon = document.querySelector(
          `[data-customer-id="${customer.id}"]`
        );

        if (targetCustomerInBalloon) {
          targetCustomerInBalloon.classList.add("active");
        }
      }
    },
    async toggleCustomerType(type) {
      if (type === "ps" && !this.onlyPs) {
        this.onlyPs = true;
        this.onlyCompanies = false;
        this.customerType = "ps";
      } else if (type === "companies" && !this.onlyCompanies) {
        this.onlyPs = false;
        this.onlyCompanies = true;
        this.customerType = "companies";
      } else {
        this.onlyPs = false;
        this.onlyCompanies = false;
        this.customerType = "";
      }

      await this.$nextTick();
      this.removeAllMarkers();
      this.addMarkers(this.locations);
    }
  }
};
</script>

<style lang="scss">
.customer-toggle-button {
  background-color: #ffffff;
}
.balloon-list {
  max-height: 200px;
  overflow-y: scroll;
  list-style: none !important;
  padding-left: 0 !important;

  li {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    cursor: pointer;

    span {
      display: inline-block;
      position: relative;
      width: 18px;
      height: 18px;
      margin-right: 6px;
      border: 2px solid;
      border-radius: 50%;
    }

    strong {
      display: inline-block;
    }

    &.balloon-item-ps {
      span {
        border-color: #2096f4;
      }
    }

    &.balloon-item-ps.active {
      span {
        border-color: #2096f4;

        &::before {
          position: absolute;
          content: "";
          width: 10px;
          height: 10px;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0);
          border-radius: 50%;
          background-color: #2096f4;
        }
      }

      strong {
        color: #2096f4;
      }
    }

    &.balloon-item-company {
      span {
        border-color: #f44335;
      }
    }

    &.balloon-item-company.active {
      span {
        border-color: #f44335;

        &::before {
          position: absolute;
          content: "";
          width: 10px;
          height: 10px;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0);
          border-radius: 50%;
          background-color: #f44335;
        }
      }

      strong {
        color: #f44335;
      }
    }
  }
}

.ymaps-2-1-79-copyright__wrap,
.ymaps-2-1-79-gotoymaps {
  display: none !important;
}
</style>
